// Angular Import
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';

// project import
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { BasicAuthInterceptor } from 'src/app/theme/shared/_helpers/basic-auth.interceptor';
import { ErrorInterceptor } from 'src/app/theme/shared/_helpers/error.interceptor';
import { AppRoutingModule } from './app/app-routing.module';
import { SharedModule } from './app/theme/shared/shared.module';

// third party
import { ToastrModule } from 'ngx-toastr';
import { provideSweetAlert2 } from '@sweetalert2/ngx-sweetalert2';
if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    // importProvidersFrom(BrowserModule, AppRoutingModule,ToastrModule.forRoot({
    //     positionClass: 'toast-top-right',
    //     timeOut: 3000,
    //   }), SharedModule, FormsModule, ReactiveFormsModule),

    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      SharedModule,
      FormsModule,
      ReactiveFormsModule,
      ToastrModule.forRoot({
        timeOut: 2000,
        positionClass: 'toast-bottom-right',
        closeButton: true,
        progressBar: true,
        progressAnimation: 'increasing',
        preventDuplicates: true,
        tapToDismiss: true,
        newestOnTop: true,
        toastClass: 'ngx-toastr custom-toast'
      })
    ),
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideSweetAlert2({
      fireOnInit: false,
      dismissOnDestroy: true
    })
  ]
}).catch((err) => console.error(err));
